import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { CLIENT_NOTE } from '../../../common/constants/routingConstants'
import { useAppDispatch } from '../../../data/store'
import { useLazyGetNoteQuery } from '../../clientNotes/data/notesApi'
import { setSelectedClientId } from '../../clients/clientDetails/data/ltClientSlice'

const useNavigateToClientNote = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [getNote] = useLazyGetNoteQuery()

  return useCallback(
    async (clientId: string, noteId: string) => {
      const note = await getNote(noteId).unwrap()
      dispatch(setSelectedClientId(clientId))
      navigate(`${CLIENT_NOTE.route}?id=${noteId}`, { state: { note } })
    },
    [dispatch, getNote, navigate],
  )
}

export default useNavigateToClientNote
